module.exports = __webpack_public_path__ + "static/img/company_page bottom_desktop.b9fc2165.jpg";